export default {
  welcome: 'Hola',
  message: '¿en qué te podemos ayudar? Por favor, ayúdanos a clasificar el ticket.',
  message2_1: 'Entiendo. Deseas realizar un requerimiento de',
  message2_2: 'para el departamento de',
  message2_3: 'sobre',
  message2_4: '. Por favor completa la información que te pedimos a continuación.',
  next_step: 'Siguiente'
}
